import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';

const state: BusinessState = {
  searchOptions: { page: 1, itemsPerPage: 10, query: '' },
  business: {
    business_contacts: [
      {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        phone: '',
        position_title: '',
      },
    ],
    business_addresses: [
      {
        address1: '',
        address2: '',
        city: '',
        postcode: '',
        country: '',
        state: '',
      },
    ],
  },
  allBusinesses: [],
};

const getters: GetterTree<BusinessState, RootState> = {
  business(state): Nullable<Model> {
    const { business } = state;
    return business;
  },
};

const actions: ActionTree<BusinessState, RootState> = {
  fetchList(context, options) {
    return http.v1.bus.fetchList(options).then(({ data }) => {
      const payload = data;
      const items = payload.data.data;
      return {
        items,
        total: payload.data.total,
      };
    });
  },
  fetch({ commit }, { businessOid, config }) {
    return http.v1.bus.fetch(businessOid, config).then((response) => {
      if (response.data.code === 'fetched') {
        commit('SET_BUSINESS', response.data.data);
      }
    });
  },
  create(_, business) {
    return http.v1.bus.create(business);
  },
  update({ commit }, business) {
    return http.v1.bus.update(business.object_id, business).then((response) => {
      if (response.data.data) {
        commit('SET_BUSINESS', response.data.data);
        localStorage.setItem('que_timezone', response.data.data.timezones);
      }
    });
  },
  creditCheck({ commit }, business) {
    return http.v1.bus
      .creditCheck(business.object_id, business)
      .then((response) => {
        if (response.data.data) {
          commit('SET_BUSINESS', response.data.data);
        }
      });
  },
  paymentMethods(_, oid) {
    return http.v1.bus.paymentMethods(oid);
  },
  creditLevel({ commit }, { businessOid, config }) {
    return http.v1.bus.creditLevel(businessOid, config).then((response) => {
      if (response.data.data) {
        commit('SET_BUSINESS', response.data.data);
      }
    });
  },
  all({ commit }, config: any = {}) {
    return http.v1.bus.all(config).then((response) => {
      if (response.data.data) {
        commit('SET_ALL_BUSINESSES', response.data.data);
      }
    });
  },
  users(_, { oid, config }) {
    return http.v1.bus.users(oid, config);
  },
  validateEmail(_, { businessOid, email, id }) {
    return http.v1.bus.validateEmail(businessOid, email, id);
  },
  addUser(_, { businessOid, user }) {
    return http.v1.bus.addUser(businessOid, user);
  },
  updateUser(_, { businessOid, user }) {
    return http.v1.bus.updateUser(businessOid, user.id, user);
  },
  deleteUser(_, { businessOid, userId }) {
    return http.v1.bus.deleteUser(businessOid, userId);
  },
  referralBusiness({ commit }, { businessOid, config }) {
    return http.v1.bus
      .referralBusiness(businessOid, config)
      .then((response) => {
        if (response.data.data) {
          commit('SET_BUSINESS', response.data.data);
        }
      });
  },
  validatePaymentMethod(_, { oid, payload }) {
    return http.v1.bus.validatePaymentMethod(oid, payload);
  },
  deletePaymentMethod(_, { oid, payload }) {
    return http.v1.bus.deletePaymentMethod(oid, payload);
  },
};

const mutations: MutationTree<BusinessState> = {
  SET_BUSINESS(state, payload) {
    state.business = Object.assign(state.business, payload);
  },
  ADD_CONTACT(state, payload) {
    state.business.business_contacts.push(payload);
  },
  ADD_ADDRESS(state, payload) {
    state.business.business_addresses.push(payload);
  },
  UPDATE_CONTACT(state, payload) {
    const index = state.business.business_contacts.findIndex(
      (contact) => contact.object_id === payload.object_id
    );
    if (index > -1) {
      const businessContacts = Object.assign(
        [],
        state.business.business_contacts
      );
      businessContacts[index] = payload;
      state.business.business_contacts = businessContacts;
    }
  },
  UPDATE_ADDRESS(state, payload) {
    const index = state.business.business_addresses.findIndex(
      (address) => address.object_id === payload.object_id
    );
    if (index > -1) {
      const businessAddresses = Object.assign(
        [],
        state.business.business_addresses
      );
      businessAddresses[index] = payload;
      state.business.business_addresses = businessAddresses;
    }
  },
  DELETE_CONTACT(state, payload) {
    const index = state.business.business_contacts.findIndex(
      (contact) => contact.object_id === payload
    );
    if (index > -1) {
      state.business.business_contacts.splice(index, 1);
    }

    if (
      state.business.billing_contact &&
      state.business.billing_contact.object_id === payload
    ) {
      state.business.billing_contact = null;
    }
  },
  DELETE_ADDRESS(state, payload) {
    const index = state.business.business_addresses.findIndex(
      (address) => address.object_id === payload
    );
    if (index > -1) {
      state.business.business_addresses.splice(index, 1);
    }

    if (
      state.business.billing_address &&
      state.business.billing_address.object_id === payload
    ) {
      state.business.billing_address = null;
    }
  },
  SET_ALL_BUSINESSES(state, payload) {
    state.allBusinesses = payload;
  },
  SET_SEARCH_OPTIONS(state, payload) {
    state.searchOptions = payload;
  },
};

const business: Module<BusinessState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default business;
